import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { FilterStateService } from 'src/app/core/services/filter-state.service';
import { GeneralService } from 'src/app/core/services/general.service';
import { HubLevelService } from 'src/app/core/services/hub-level.service';
import { TransactionBalanceFilterService } from 'src/app/core/services/transaction-balance-filter.service';
import { PapiCustomDropdownComponent } from 'src/app/shared/custom-components/papi-custom-dropdown/papi-custom-dropdown.component';

@Component({
  selector: 'filter-modal',
  templateUrl: './filter-modal.component.html',
  styleUrls: ['./filter-modal.component.scss'],
})
export class FilterModalComponent implements OnInit, OnDestroy {
  @ViewChild('productsDropdown') productsDropdown: any;
  @ViewChild('directionsDropdown') directionsDropdown: any;
  @ViewChild('partnersDropdown') partnersDropdown: any;
  @ViewChild('partnerDropdown2') partnerDropdown2: any;

  @Input() startDate: string;
  @Input() endDate: string;
  @Input() movementType: string;
  @Input() productsList: any = [];

  @Output() filterApplied = new EventEmitter<{data: any, closeFilter: boolean}>();
  @Output() closeModal = new EventEmitter<void>();
  @Output() onResetTable = new EventEmitter<void>();
  enablePartnerDropdown: boolean = false;
  enableCountriesDropdown: boolean = false;
  originalProductsList: any = [];
  directionList: any[] = [];
  organisationList: any;
  countriesList: any;
  options: any[];
  cntry: any[];
  timeouts: any[] = [];
  searcheCountryName = '';

  selectedDirectionsList = new Set();
  selectedProductsList = new Set();
  selectedPartnerCodes = new Set();
  selectedCountryName = new Set();
  selectedPartners: any = new Set();
  selectedCountries: any = new Set();

  objectsArray: any = [];
  countryArray: any = [];

  selectedDirection: string = 'Select';
  PartnerNames: string = 'Select';
  CountryNames: string = 'Select';

  forceRerenderProductDropdown: boolean = true;
  forceRerenderDirectionDropdown: boolean = true;
  forceRerenderPartnerDropdown: boolean = true;
  forceRerenderCountryDropdown: boolean = true;

  originalPartnersList: any[] = [];
  originalCountriesList: any[] = [];
  filteredCountries: any[] = [];

  private subscription: Subscription;

  constructor(
    private hublevelService: HubLevelService,
    private GS: GeneralService,
    private filterStateService: FilterStateService,
    private filterService: TransactionBalanceFilterService
  ) {}

  ngOnInit() {
    this.getDirectionList();
    // Store original products list
    this.originalProductsList = [...this.productsList];
    
    this.subscription = this.filterStateService.getFilterState().subscribe((state) => {
    
      if (state.selectedDirection !== 'Select') {
        this.enablePartnerDropdown = true;
        if (state.selectedPartners.size === 0) {
          this.enableCountriesDropdown = true;
        }
        if (!this.options || !this.cntry) {
          this.getHubPartnerandCountryDropdownByDirection();
        }
      }
      this.selectedPartners = state.selectedPartners;
      this.selectedCountries = state.selectedCountries;
      this.selectedProductsList = state.selectedProductsList;
      this.selectedDirection = state.selectedDirection;
      this.selectedPartnerCodes = state.selectedPartnerCodes;
      this.selectedCountryName = state.selectedCountryName;

      if (state.selectedPartners.size > 0) {
        this.PartnerNames = `${state.selectedPartners.size} Selected`;
      }

      if (state.selectedCountries.size > 0) {
        this.CountryNames = `${state.selectedCountries.size} Selected`;
      }
    });

    // Initialize filteredCountries
    this.filteredCountries = [];
  }

  getDirectionList() {
    this.directionList = [
      { label: 'All', value: 1 },
      { label: 'Send', value: 2 },
      { label: 'Receive', value: 3 },
    ];
  }

  getProductList(partnerCode: string) {
    this.filterService.getProductList(partnerCode).subscribe((response: any) => {
      //   this.errorHandlerService.checkAndShowpageError(response.responseCode, 'balance');
      if (response.token != null && response.token != '') {
        localStorage.setItem('token_key', response.token);
      }
      let list: any = response;
      if (list != null && list.result != null) {
        this.productsList = [{ label: 'All', value: 0 }].concat(
          list.result.responseData.map((p, i) => ({
            label: p.productName,
            value: i + 1,
          }))
        );
        // Store the original list after it's populated
        this.originalProductsList = [...this.productsList];
      }
    });
  }

  addDirections({ label }: any) {
    this.selectedPartners = new Set();
    this.selectedPartnerCodes = new Set();
    this.selectedCountries = new Set();
    this.selectedCountryName = new Set();
    
    this.partnersDropdown.reset();
    this.partnerDropdown2.reset();
    
    this.selectedDirection = label;
    this.enablePartnerDropdown = true;
    this.enableCountriesDropdown = true;
    this.PartnerNames = 'Select';
    this.CountryNames = 'Select';

    this.filterStateService.updateFilterState({
      selectedDirection: this.selectedDirection,
      selectedPartners: new Set(),
      selectedPartnerCodes: new Set(),
      selectedCountries: new Set(),
      selectedCountryName: new Set(),
      PartnerNames: this.PartnerNames,
      CountryNames: this.CountryNames,
      enablePartnerDropdown: this.enablePartnerDropdown,
    });

    this.getHubPartnerandCountryDropdownByDirection();
  }

  getHubPartnerandCountryDropdownByDirection() {
    let request = {
      startDate: this.startDate,
      endDate: this.endDate,
      direction: this.selectedDirection === 'All' || this.selectedDirection === 'Select' ? null : this.selectedDirection,
      movementType: this.movementType,
    };

    this.hublevelService.getHubPartnerCountryListByDiretion(request).subscribe((response: any) => {
      localStorage.setItem('token_key_v2', response.token);
      if (response != null && response.result != null) {
        this.organisationList = response.result.responseData;
        this.options = this.getPartners().map((part) => {
          return { ...part, value: part.partnercode, label: part.orgname };
        });
        this.sortByPartner();

        let uniq: any = {};
        this.countriesList = response.result.responseData.filter(
          (obj: { countryname: string | number }) => !uniq[obj.countryname] && (uniq[obj.countryname] = true)
        );
        this.cntry = this.getCountries();
        this.filteredCountries = [...this.cntry];
        this.sortByCountry();

        this.originalPartnersList = [...this.options];
        this.originalCountriesList = [...this.cntry];
      }
    });
  }

  getPartners(): any[] {
    if (!this.organisationList) {
      return [];
    }
    return this.organisationList
      .filter((item: { orgname: any }) => item.orgname !== null)
      .map((item: { orgname: any }, index: any) => {
        return {
          ...item,
          label: item.orgname,
          value: index,
        };
      });
  }

  getCountries(): any[] {
    if (!this.countriesList) return [];
    
    let countries = this.countriesList.map((country: any) => {
      return {
        countryname: country.countryname,
        value: country.countryname,
        label: country.countryname
      };
    });

    return [...countries];
  }

  sortByCountry() {
    this.countriesList.sort((a: { countryname: string }, b: { countryname: any }) =>
      a.countryname?.localeCompare(b.countryname)
    );
  }

  sortByPartner() {
    this.organisationList.sort((a: { orgname: string }, b: { orgname: any }) => a.orgname?.localeCompare(b.orgname));
  }

  selectPartner(item: any) {
    if (Array.from(this.selectedPartnerCodes).length != null) {
      this.enableCountriesDropdown = false;
    } else {
      this.enableCountriesDropdown = false;
    }

    if (item.orgname === 'All') {
      this.objectsArray = [];
      this.selectedPartners = new Set();
      this.selectedPartnerCodes = new Set();
      this.PartnerNames = 'Select';
      this.enableCountriesDropdown = true;
    } else {
      if (!this.selectedPartnerCodes.has(item.partnercode)) {
        this.selectedPartners.add(item);
        this.selectedPartnerCodes.add(item.partnercode);
        this.enableCountriesDropdown = false;
        this.PartnerNames = `${this.selectedPartners.size} Selected`;
      }
    }

    this.filterStateService.updateFilterState({
      selectedPartners: this.selectedPartners,
      selectedPartnerCodes: this.selectedPartnerCodes,
      PartnerNames: this.PartnerNames,
      enableCountriesDropdown: this.enableCountriesDropdown,
    });
  }

  selectCountry(item: any, dropdownComponent: PapiCustomDropdownComponent) {
    dropdownComponent.dropdownOpen = false;

    if (item.countryname === 'All') {
      this.CountryNames = 'All';
      this.countryArray = [];
      this.selectedCountries = new Set();
      this.selectedCountryName = new Set();
      return;
    }

    this.selectedCountries.add(item);
    this.selectedCountryName.add(item.countryname);
    this.CountryNames = item.countryname;
    let request = {
      startDate: this.startDate,
      endDate: this.endDate,
      country:
        Array.from(this.selectedCountryName).length == 0 ? null : Array.from(this.selectedCountryName).toString(),
      movementType: this.movementType,
    };
    this.hublevelService.getHubPartnerCountryListByCountryPartner(request).subscribe((response: any) => {
      localStorage.setItem('token_key_v2', response.token);

      if (response != null && response.result != null) {
        this.organisationList = response.result.responseData;
        this.options = this.getPartners().map((part) => {
          return { ...part, value: part.partnercode, label: part.orgname };
        });
        this.sortByPartner();
      }
    });

    this.filterStateService.updateFilterState({
      selectedCountries: this.selectedCountries,
      selectedCountryName: this.selectedCountryName,
      CountryNames: this.CountryNames,
    });
    this.searcheCountryName='';
    this.filteredCountries = [...this.originalCountriesList];
  }

  removePartner(partner: any) {
    this.selectedPartners.delete(partner);
    if (this.selectedPartners.size === 0) {
      this.enableCountriesDropdown = true;
      this.PartnerNames = 'Select';
      this.CountryNames = 'Select';
      this.partnersDropdown.reset();
    }
    this.selectedPartnerCodes.delete(partner.partnercode);
    this.objectsArray = [];
    this.options = [...this.getPartners()];

    this.filterStateService.updateFilterState({
      selectedPartners: this.selectedPartners,
      selectedPartnerCodes: this.selectedPartnerCodes,
      PartnerNames: this.PartnerNames,
      enableCountriesDropdown: this.enableCountriesDropdown,
    });

    this.applyFilter(false);
  }

  removeCountry(country: any) {
    this.selectedCountries.delete(country);
    this.selectedCountryName.delete(country.countryname);
    this.searcheCountryName='';
    if (this.selectedCountries.size === 0) {
      this.CountryNames = 'Select';
    }
    this.countryArray = [];
    this.cntry = [...this.getCountries()];
    this.filteredCountries = [...this.originalCountriesList];
    this.filterStateService.updateFilterState({
      selectedCountries: this.selectedCountries,
      selectedCountryName: this.selectedCountryName,
      CountryNames: this.CountryNames,
    });

    this.applyFilter(false);
  }

  removeDirection() {
    this.selectedDirection = 'Select';
    this.enablePartnerDropdown = false;
    this.enableCountriesDropdown = false;
    this.PartnerNames = 'Select';
    this.CountryNames = 'Select';

    // Clear all partner and country selections
    this.selectedPartners = new Set();
    this.selectedPartnerCodes = new Set();
    this.selectedCountries = new Set();
    this.selectedCountryName = new Set();

    // Reset dropdowns
    this.partnersDropdown.reset();
    this.partnerDropdown2.reset();
    this.directionsDropdown.reset();

    // Reset options and countries lists to original state
    if (this.originalPartnersList.length) {
      this.options = [...this.originalPartnersList];
    }
    if (this.originalCountriesList.length) {
      this.cntry = [...this.originalCountriesList];
      this.filteredCountries = [...this.originalCountriesList];
    }

    this.filterStateService.updateFilterState({
      selectedDirection: this.selectedDirection,
      selectedPartners: this.selectedPartners,
      selectedPartnerCodes: this.selectedPartnerCodes,
      selectedCountries: this.selectedCountries,
      selectedCountryName: this.selectedCountryName,
      PartnerNames: this.PartnerNames,
      CountryNames: this.CountryNames,
      enablePartnerDropdown: this.enablePartnerDropdown,
      enableCountriesDropdown: this.enableCountriesDropdown
    });

    this.applyFilter(false);
  }

  removeProduct(product: any) {
    this.selectedProductsList.delete(product);
    this.productsDropdown.reset();
    this.productsList = [...this.originalProductsList];

    this.filterStateService.updateFilterState({
      selectedProductsList: this.selectedProductsList,
    });

    this.applyFilter(false);
  }

  onPartnersSearch(e: string): void {
    if (!this.originalPartnersList.length) {
      this.originalPartnersList = [...(this.options || [])];
    }

    if (e) {
      this.options = this.originalPartnersList.filter((partner) =>
        partner.orgname.toLowerCase().includes(e.toLowerCase())
      );
    } else {
      this.options = [...this.originalPartnersList];
    }
  }

  onCountriesSearch(event: any): void {
    const searchTerm = event.target.value.toLowerCase().trim();

    if (!this.originalCountriesList.length) {
      this.originalCountriesList = [...(this.cntry || [])];
    }

    if (searchTerm) {
      this.filteredCountries = this.originalCountriesList.filter((country) =>
        country.countryname?.toLowerCase().includes(searchTerm)
      );
    } else {
      this.filteredCountries = [...this.originalCountriesList];
    }
  }

  onProductsSearch(e: string): void {
    if (!this.originalProductsList.length) {
      this.originalProductsList = [...(this.productsList || [])];
    }

    if (e) {
      this.productsList = this.originalProductsList.filter((product) =>
        product.label?.toLowerCase().includes(e.toLowerCase().trim())
      );
    } else {
      this.productsList = [...this.originalProductsList];
    }
  }

  addProducts({ label }: any) {
    if (label === 'All') {
      this.selectedProductsList.clear();
    }
    else{
      this.selectedProductsList.add(label);
    }

    this.filterStateService.updateFilterState({
      selectedProductsList: this.selectedProductsList,
    });
  }

  applyFilter(closeFilter: boolean = true) {
    const filterData = {
      selectedDirection: this.selectedDirection,
      selectedProducts: Array.from(this.selectedProductsList),
      selectedPartners: Array.from(this.selectedPartnerCodes),
      selectedPartnerNames: Array.from(this.selectedPartners),
      selectedCountries: Array.from(this.selectedCountryName),
    };
    
    this.filterApplied.emit({ data: filterData, closeFilter });
  }

  close() {
    this.closeModal.emit();
  }

  getAppliedFiltersCount(): number {
    let count = 0;
    if (this.selectedProductsList && this.selectedProductsList.size > 0) count += 1;
    if (this.selectedDirectionsList && this.selectedDirectionsList.size > 0) count += 1;
    if (this.selectedPartners && this.selectedPartners.size > 0) count += 1;
    if (this.selectedCountries && this.selectedCountries.size > 0) count += 1;
    return count;
  }

  resetTable() {
    this.resetDropdowns();
    this.onResetTable.emit();
  }

  resetDropdowns() {
    this.selectedPartnerCodes = new Set();
    this.selectedPartners = new Set();
    this.selectedCountryName = new Set();
    this.selectedCountries = new Set();
    this.selectedProductsList = new Set();
    this.selectedDirection = 'Select';
    this.PartnerNames = 'Select';
    this.CountryNames = 'Select';
    this.enablePartnerDropdown = false;
    this.enableCountriesDropdown = false;

    this.productsDropdown.reset();
    this.directionsDropdown.reset();
    this.partnersDropdown.reset();
    this.partnerDropdown2.reset();

    this.filterStateService.updateFilterState({
      selectedPartners: new Set(),
      selectedCountries: new Set(),
      selectedProductsList: new Set(),
      selectedDirection: 'Select',
      selectedPartnerCodes: new Set(),
      selectedCountryName: new Set(),
      PartnerNames: 'Select',
      CountryNames: 'Select',
      enablePartnerDropdown: false,
      enableCountriesDropdown: false,
    });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    for (const timeout of this.timeouts) {
      clearTimeout(timeout);
    }
  }
}
